<template>
  <!-- app-main -->
  <main id="site-content" role="main" class="app-main scrollbar">
    <div class="app-main__outer">
      <div class="app-main__inner">
        <div class="app-page-title">
          <div class="page-title-wrapper d-flex justify-content-between">
            <div class="page-title-heading">
              {{ pageTitle }}
            </div>
            <div class="page-actions">
              <div class="icon-wrapper icon-wrapper-alt dropdown">
                <span class="icon-wrapper-bg bg-primary rounded-circle" @click.stop.prevent="showNotification"></span>
                <i class="ti ti-bell-filled" @click.stop.prevent="showNotification"></i>
                <span v-show="unRead > 0" class="badge badge-danger">{{ unRead <= 99 ? unRead : '99+' }}</span>
                <div v-if="notificationDropdown" tabindex="-1" role="menu" class="dropdown-menu show left-auto notification">
                  <h2 class="h5" tabindex="-1">Notifications</h2>
                  <ul class="list-group">
                    <li v-for="(item, key) in groups" :key="key" :class="`${item.id == this.groupSelected ? 'active' : ''}`" @click.stop.prevent="handleChangeGroup(item.id)">
                      {{ item.label }}
                    </li>
                  </ul>
                  <hr />
                  <div class="list-notification scrollbar" ref="listNotification">
                    <div v-if="listToday.length > 0" class="today-notification">
                      <strong>Today</strong>
                      <div class="item-notification" v-for="(item, key) in listToday" :key="key">
                        <div class="thumbnail">
                          <img :src="`/assets/images/${item.thumbnail}`" />
                        </div>
                        <div class="meta">
                          <p class="title">{{ item.title || '' }}</p>
                          <p class="message">{{ item.messenger || '' }}</p>
                        </div>
                      </div>
                    </div>
                    <div v-if="listEarlier.length > 0" class="earlier-notification">
                      <strong>Earlier</strong>
                      <div class="item-notification" v-for="(item, key) in listEarlier" :key="key">
                        <div class="thumbnail">
                          <img :src="`/assets/images/${item.thumbnail}`" />
                        </div>
                        <div class="meta">
                          <p class="title">{{ item.title || '' }}</p>
                          <p class="message">{{ item.messenger || '' }}</p>
                        </div>
                      </div>
                    </div>
                    <div v-if="listToday.length == 0 && listEarlier.length == 0" class="d-flex justify-content-center w-100">No new notifications</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="master-tool-app" class="master-tool">
          <slot name="body" />
        </div>
      </div>
    </div>
  </main>
  <!-- #app-main -->
</template>

<script>
export default {
  data() {
    return {
      notificationDropdown: 0,
      groupSelected: '',
      groups: [
        {
          id: '',
          label: 'All'
        },
        {
          id: 'account',
          label: 'Account'
        },
        {
          id: 'order',
          label: 'Order'
        }
      ]
    }
  },
  created() {
    document.title = this.pageTitle
  },
  computed: {
    data() {
      return this.$store.getters.data?.notifications || {}
    },
    listNotification() {
      return this.data.data || {}
    },
    listToday() {
      let list = []
      let today = new Date()
      today.setHours(0, 0, 0, 0)
      let todayTimestamp = Math.floor(today.getTime() / 1000)
      Object.entries(this.listNotification).forEach(([, item]) => {
        if (item.date_created && todayTimestamp <= item.date_created) {
          list.push(item)
        }
      })
      return list
    },
    listEarlier() {
      let list = []
      let today = new Date()
      today.setHours(0, 0, 0, 0)
      let todayTimestamp = Math.floor(today.getTime() / 1000)
      Object.entries(this.listNotification).forEach(([, item]) => {
        if (item.date_created && todayTimestamp > item.date_created) {
          list.push(item)
        }
      })
      return list
    },
    unRead() {
      let unRead = 0
      if (this?.data?.unread) {
        unRead = Math.max(0, parseInt(this.data.unread))
      }
      return unRead
    }
  },
  methods: {
    showNotification() {
      this.notificationDropdown = this.notificationDropdown ? 0 : 1
      if (this.notificationDropdown) this.$emitter.emit(`notifications.readAll`)
    },
    handleChangeGroup(value) {
      this.groupSelected = value
      this.$emitter.emit(`notifications.filter`, {
        type: this.groupSelected
      })
    }
  },
  props: {
    pageTitle: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
.page-title-wrapper .page-actions {
  > * {
    cursor: pointer;
  }
  .badge {
    position: absolute;
    z-index: 99;
    top: -7px;
    right: -7px;
    border-radius: 20px;
    padding: 5px 7px;
  }
  .list-group {
    padding: 0 15px 15px 15px;
    flex-direction: row;
    li {
      padding: 6px 13px;
      background: #e5e5e5;
      border-radius: 40px;
      margin-right: 5px;
      line-height: 1;
      &.active {
        background: #d1e5ff;
        color: #0064d1;
        font-weight: 500;
      }
    }
  }
  .icon-wrapper {
    width: 40px;
    height: 40px;
    overflow: visible;
    i {
      font-size: 20px;
    }
  }
  .dropdown-menu.notification {
    width: 380px;
    left: auto;
    right: 0;
    top: calc(100% + 10px);
    padding: 0 0 10px 0;
    user-select: none !important;
    strong {
      font-size: 16px;
      font-weight: 500;
    }
    hr {
      margin: 0 !important;
    }
    h2 {
      font-weight: 500;
      font-size: 22px;
      padding: 10px 15px;
      margin: 0;
    }
    .list-notification {
      max-height: 700px;
      overflow: auto;
      z-index: 99999;
      padding: 10px 15px;
    }
    .item-notification {
      margin-top: 10px;
      display: flex;
      .thumbnail {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 48px;
        height: 48px;
        min-width: 48px;
        border: 1px solid #ccc;
        border-radius: 48px;
        overflow: hidden;
        img {
          width: 28px;
          height: 28px;
        }
      }
      .meta {
        padding-left: 10px;
      }
      .title {
        font-weight: 500;
      }
      p {
        margin-bottom: 0;
      }
    }
  }
}
</style>
